import React, { useEffect } from "react";
import BreadCrumb from "../../common/breadcrumb";
import WelcomeWidget from "../../pages/dashboards/ecommerce/welcome-widget";
import OrderStatistics from "../../pages/dashboards/ecommerce/order-statistics";
import Widgets from "../../pages/dashboards/ecommerce/widgets";
import SalesRevenue from "../../pages/dashboards/ecommerce/sales-revenue";
import TrafficResources from "../../pages/dashboards/ecommerce/traffic-resources";
import ProductsOrders from "../../pages/dashboards/ecommerce/products-orders";
import CustomerService from "../../pages/dashboards/ecommerce/customer-service";
import SalesMonth from "../../pages/dashboards/ecommerce/sales-month";
import TopSellingProducts from "../../pages/dashboards/ecommerce/top-selling-products";
import Audience from "../../pages/dashboards/ecommerce/audience";
import { useNavigate } from "react-router-dom";

const AdminDashboard = () => {
  /*  const navigate = useNavigate();
    useEffect(() => navigate("/dashboard"), [navigate]); */

  return (
    <React.Fragment>
      <BreadCrumb title="Admin Portal" pageTitle="Dashboards" />
      <div className="grid grid-cols-12 gap-x-5">
        <WelcomeWidget />
        <OrderStatistics />
        <Widgets />
        <SalesRevenue />
        <TrafficResources />
        <ProductsOrders />
        <CustomerService />
        <SalesMonth />
        <TopSellingProducts />
        <Audience />
      </div>
    </React.Fragment>
  );
};

export default AdminDashboard;
